module.exports = "https://static.wanderu.com/ui-react/_next/static/media/us.3cc0d38b.svg";